import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import GenericDialog from "../GenericDialog";

const EditLabelDialog = ({
  open,
  setOpen,
  entry,
  onCloseSuccess = null,
  onClose = null
}) => {
  const [internalEntry, setInternalEntry] = useState([]);

  React.useEffect(() => {
    if (open) setInternalEntry(entry);
  }, [open]);

  const onValueChange = (value, property) =>
    setInternalEntry({ ...internalEntry, [property]: value });

  const handleClose = () => {
    setOpen(false);
    if (onClose !== null) onClose();
  };

  const handleCloseSuccess = () => {
    if (onCloseSuccess !== null) {
      onCloseSuccess(internalEntry);
    }
    setOpen(false);
  };
  const actions = (
    <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button onClick={handleCloseSuccess} color="primary" autoFocus>
        Save
      </Button>
    </>
  )
  return (
    <GenericDialog
      open={open}
      onClose={handleClose}
      maxWidth={"lg"}
      title={"Edit Label"}
      actions={actions}
    >
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <TextField
              id="notes-input"
              label="Label"
              value={internalEntry.label}
              onChange={(event) => onValueChange(event.target.value, "label")}
              style={{ minWidth: "300px" }}
            />
          </Grid>

          <Grid item sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={internalEntry.isActive}
                  onChange={(event) =>
                    onValueChange(event.target.checked, "isActive")
                  }
                />
              }
              label="Active Prompt"
            />
          </Grid>
        </Grid>
    </GenericDialog>
  );
};

export default EditLabelDialog;
